// Angular:
import {
    Component,
    ContentChild,
    Inject,
    Input,
    OnDestroy,
    TemplateRef,
    ViewChild
} from '@angular/core';
import { Subject } from 'rxjs';

// Dependencies:
import { ensureBool } from '@trademe/tangram';
import { notNull } from '../../helpers/not-null.helper';
import { StepIndicatorIconDirective } from '../step-indicator-icon/step-indicator-icon.directive';
import {
    IStepIndicatorComponent,
    stepIndicatorComponentInjection
} from '../step-indicator/istep-indicator.component';

@Component({
    selector: 'tm-step-indicator-item',
    templateUrl: 'step-indicator-item.component.html',
    standalone: false
})
export class StepIndicatorItemComponent implements OnDestroy {
    @Input()
    public get id(): any {
        return notNull(this._id, 'id');
    }
    public set id(value: any) {
        this._id = value;
    }
    private _id: any;

    @Input({ transform: (value: unknown) => ensureBool('disabled', value) })
    public disabled: boolean;

    @Input()
    public get title(): string {
        return notNull(this._title, 'title');
    }
    public set title(value: string) {
        this._title = value;
    }
    private _title: string;

    @ContentChild(StepIndicatorIconDirective, { read: TemplateRef })
    public icon: TemplateRef<any>;

    @ViewChild('content', { read: TemplateRef, static: true })
    public content: TemplateRef<any>;

    public active: boolean;

    private _destroyed$ = new Subject();

    constructor(
        @Inject(stepIndicatorComponentInjection)
        private stepIndicatorComponent: IStepIndicatorComponent
    ) {}

    public ngOnDestroy(): void {
        this._destroyed$.next(true);
    }

    public select(): void {
        this.stepIndicatorComponent.select(this);
    }
}
